import { isBoardSession } from "../helpers/board";
import { useLocalOrRemoteMedia } from "./ovenmedia";
import { useCallback } from "react";
import { MeetingSession } from "@kalyzee/kast-web-sdk/websocket";
import { useMeetingUtilsContext } from "../contexts/meetingUtils/context";

export const useBoardMedia = () => {
  const { populated, containerAPI } = useMeetingUtilsContext();
  return useLocalOrRemoteMedia(
    containerAPI,
    useCallback((s: MeetingSession) => isBoardSession(s, populated.activity), [populated.activity]),
  );
};